import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-04/lesson-08/task-02";

const task: Slide = {
  titleHtml:
    "The datasheet of a measurement microphone is given below. What is the usable dynamic range<br /> if one desires to have a minimum signal to noise ratio of 20 dB and a headroom of 10 dB.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/08/task/task-2-item-1.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
